// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

/**
 * The rates in force per pair and source: 1 currency1 = buyRate / sellRate
 * currency2, buy being what the source pays for one currency1 and sell what it
 * charges. Each row is one of its source's pairs: while the source has syncEnabled,
 * core-cron fills both rates in from its provider; under a manual source they are
 * kept by hand. Either may be empty — a new row waits for its first sync, and a
 * bank may not trade a currency both ways.
 */
export default class CurrentCurrencyRatesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicCurrentCurrencyRates';
        this.Server = this.props.context.getState().server.publicCurrentCurrencyRates;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['source.name'];
        this.showDatePicker = false;

        const defaultHead = [
            {
                id: 'sourceId',
                required: true,
                label: 'source',
                alignRight: false,
                cell: 'Select',
                from: 'publicCurrencyRateSources',
                object: 'source',
                show: 'name',
                displayGrid: true,
                customSort: 'source.name'
            },
            {
                id: 'currency1Id',
                required: true,
                label: 'currency1',
                alignRight: false,
                cell: 'Select',
                from: 'publicCurrencies',
                object: 'currency1',
                show: 'code',
                displayGrid: true
            },
            {
                id: 'currency2Id',
                required: true,
                label: 'currency2',
                alignRight: false,
                cell: 'Select',
                from: 'publicCurrencies',
                object: 'currency2',
                show: 'code',
                displayGrid: true
            },
            { id: 'buyRate', label: 'buyRate', alignRight: true, cell: 'Number', displayGrid: true },
            { id: 'sellRate', label: 'sellRate', alignRight: true, cell: 'Number', displayGrid: true },
            // Written only by the sync; the API ignores it on a request.
            { id: 'lastSyncDate', label: 'lastSyncDate', alignRight: false, cell: 'DateTime', displayGrid: true, disableEditor: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
